import { Injectable } from "@angular/core";
import { ITipoCorso } from "app/shared/models/tipo_corso.interface";
import { BASEMysqlService } from "./_base";
@Injectable({
  providedIn: 'root'
})
export class MysqlServiceTipiCorso extends BASEMysqlService {

    prefix = 'tipi_corso_'
  
    //////////////////////////////////////////////////////////////////////////////////////////
  
    list(): Promise<any> {
      let data = {
        auth: this.getAuth(),
      }
  
      // console.log(data)
  
      return this.http.post(this.URL_BASE + this.prefix + 'list', data).toPromise();
    }
  
    get(id): Promise<any> {
      let data = {
        auth: this.getAuth(),
        id: id
      }
  
      // console.log(data)
  
      return this.http.post(this.URL_BASE + this.prefix + 'get', data).toPromise();
    }
  
    upsert(item: ITipoCorso): Promise<any> {
      let data = {
        auth: this.getAuth(),
        item: item
      }
  
      return this.http.post<ITipoCorso[]>(this.URL_BASE + this.prefix + 'upsert', data).toPromise();
    }
  
    delete(id: number): Promise<any> {
      let data = {
        auth: this.getAuth(),
        id: id
      }
  
      return this.http.post(this.URL_BASE + this.prefix + 'delete', data).toPromise();
    }
  
  }